<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';
    import Clipboard from "svelte-clipboard";
    import Fa from 'svelte-fa'
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faSpinner,faGift,faCrown } from '@fortawesome/free-solid-svg-icons';
    import Time from "svelte-time";
    import Swal from 'sweetalert2'

    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    let loading = false
    let bnakDep = {}
    let names;

    let camList = {}
    let isList=  false

    let cpCode = ""

    export let params = {};
    let sid
    $: {
        if (params && params.sid) {
            sid = params.sid
            campaignList()
        } 
    }

    async function campaignList() {
        isList = false
        const res = await fetch(window.localStorage.getItem("apiurl")+"xapi/getcampaign", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token')
            },
            body: qs.stringify({id:sid})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            camList = json.payload
            isList = true
		} else {
            push('/promotion')
            throw new Error(json);
		}
    }
    async function applyCoupon() {
        
        const res = await fetch(window.localStorage.getItem("apiurl")+"xapi/applycode", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token')
            },
            body: qs.stringify({campaign:sid,code:cpCode})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            Swal.fire({
                heightAuto: false,
                title: 'ทำรายการสำเร็จ!',
                text: '',
                icon: 'success',
                confirmButtonText: 'OK' 
            })
            push('/promotion')
		} else {
            Swal.fire({
                heightAuto: false,
                title: 'ไม่สามารถทำรายการได้',
                text: json.message,
                icon: 'error',
                confirmButtonText: 'OK' 
            })
            throw new Error(json);
		}
    }
    
</script>
<div class="default-home">
<div class="row  mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; bacbackground-repeat: no-repeat;
background-attachment: fixed;
background-position: center;">
    <Header />
    
   
    <div class="col-12 text-center mt-2" ><a href="/promotion" use:link style="text-decoration: none;"><h4 style="color: rgb(230, 196, 119) !important;"><Fa icon={faCrown} /> สิทธิพิเศษ</h4></a></div>
    <div class="col-12 " style="min-height: 500px;">
        {#if loading}
        <div class="text-center mt-2" style="">
            <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
        </div>
        {/if}
        {#if !loading}
        <div class="card mt-2 bg-black mb-5">
            <div class="card-body">
                <div class="row ps-2 pe-2 text-white text-center">
                    {#if isList}
                    <div class="col-12 text-center mb-2 text-white">
                        {camList.campaign_name}
                    </div>
                    <div class="mb-3">
                        <label for="creditwd" class="form-label">กรอก Coupon Code</label>
                        <input type="text" class="form-control rounded-pill text-center" id="creditwd" placeholder="" bind:value={cpCode}>
                    </div>
                        <div class="col-12 text-center d-grid gap-2 mb-3">
                            <button type="button" class="btn btn-dark rounded-pill btn-gd" on:click={() => applyCoupon()}>ยืนยันคูปอง</button>
                        </div>
                   
                    {/if}
                </div>
                
            </div>
        </div>
        {/if}
    </div>
 
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3 blog-promotion">
        <HeaderThemes/>
        <div class="col-12 text-center mt-3" ><a href="/promotion" use:link style="text-decoration: none;"><h4 class="head-title"><Fa icon={faCrown} /> สิทธิพิเศษ</h4></a></div>
    <div class="col-12 " style="min-height: 500px;">
        {#if loading}
        <div class="text-center mt-2" style="">
            <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
        </div>
        {/if}
        {#if !loading}
        <div class="card mt-3 bg-black mb-5">
            <div class="card-body">
                <div class="row ps-2 pe-2 text-white text-center">
                    {#if isList}
                    <div class="col-12 text-center mb-2 text-white">
                        {camList.campaign_name}
                    </div>
                    <div class="mb-3">
                        <label for="creditwd" class="form-label">กรอก Coupon Code</label>
                        <input type="text" class="form-control rounded-pill text-center" id="creditwd" placeholder="" bind:value={cpCode}>
                    </div>
                        <div class="col-12 text-center d-grid gap-2 mb-3">
                            <button type="button" class="btn btn-dark rounded-pill btn-gd" on:click={() => applyCoupon()}>ยืนยันคูปอง</button>
                        </div>
                   
                    {/if}
                </div>
                
            </div>
        </div>
        {/if}
    </div>
    </div>
</div>
<div class="themes-home-section" style="display: none;display:flex;">
    
</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    .btn-gd{
        /* --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.6rem;
        font-weight: 300; */
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.6rem;
    }
    .pointer{
        cursor: pointer;
    }
</style>